import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var InsuranceIcon = function InsuranceIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.247 20.68a15.391 15.391 0 0 1-3.353 1.77.75.75 0 0 1-.538 0C4.789 19.924 1.5 14.105 1.5 5.163a.75.75 0 0 1 .66-.744l.45-.059c.362-.049.766-.107 1.202-.175a57.273 57.273 0 0 0 3.64-.676c1.646-.367 2.974-.768 3.85-1.186a.75.75 0 0 1 .658.006c.872.436 2.196.843 3.838 1.208a52.36 52.36 0 0 0 3.636.66 58.686 58.686 0 0 0 1.649.221.75.75 0 0 1 .667.745c0 2.891-.344 5.456-1.03 7.688a2.29 2.29 0 0 0-.061.058l-3.409 3.409-.659-.659a2.25 2.25 0 0 0-3.182 3.182l1.838 1.838zM11.625 3.83a9.837 9.837 0 0 1-.007-.004c-.974.418-2.277.798-3.84 1.147a58.73 58.73 0 0 1-3.737.694c-.368.058-.715.108-1.035.153.15 7.859 3.02 12.85 8.619 15.124V3.829zm3.905 12.89l1.72 1.72 4.47-4.47a.75.75 0 0 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 1.06-1.06z"
  }));
};

InsuranceIcon.displayName = 'InsuranceIcon';
export default InsuranceIcon;